"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("@mui/material"),t=require("../../assets/icons/TrustIcon.js");require("react/jsx-runtime");const r=e.styled(t.TrustIcon)`
  width: 16px !important;
  height: 16px !important;
  margin-left: 8px;
`;exports.CareLevelIcon=r;
